/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSubscription } from '../../models/profile-subscription';
import { ProfileSubscriptionSave } from '../../models/profile-subscription-save';

export interface CreateProfileSubscription$Params {
  id: number;
      body: ProfileSubscriptionSave
}

export function createProfileSubscription(http: HttpClient, rootUrl: string, params: CreateProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
  const rb = new RequestBuilder(rootUrl, createProfileSubscription.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileSubscription>;
    })
  );
}

createProfileSubscription.PATH = '/rest/admin/profile/{id}/subscription';
